import { render, staticRenderFns } from "./MessageWidgetChannelAvatars.vue?vue&type=template&id=64e29e08&"
import script from "./MessageWidgetChannelAvatars.vue?vue&type=script&lang=js&"
export * from "./MessageWidgetChannelAvatars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports